import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './plugins/element.js'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/title'
import 'echarts/lib/component/grid'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/chart/line'
import Moment from 'vue-moment'
Vue.config.productionTip = false
Vue.component('v-chart', ECharts)
Vue.use(Moment);
new Vue({
  render: h => h(App),
}).$mount('#app')
